<template>
    <v-card elevation="0" class="py-20px py-md-40px">
        <v-card-title class="tit tit--sm primary--text pt-0" v-if="title"> {{ title }} </v-card-title>
        <v-card-text class="py-20px py-md-40px">
            <div class="mx-auto" style="width:100%;max-width:800px">
                <slot />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String, default: null },
    },
};
</script>

<style></style>
